export default __webpack_public_path__ + "static/media/add.253edd12.svg";